import { render, staticRenderFns } from "./SmallPlayer.vue?vue&type=template&id=2382ce6c&scoped=true"
import script from "./SmallPlayer.vue?vue&type=script&lang=ts"
export * from "./SmallPlayer.vue?vue&type=script&lang=ts"
import style0 from "./SmallPlayer.vue?vue&type=style&index=0&id=2382ce6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2382ce6c",
  null
  
)

export default component.exports